module.exports = __webpack_public_path__ + "static/media/power.1fcfd691.svg";